"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PriceComponent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _storeProvider = require("../util/storeProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class PriceComponent extends _react.PureComponent {
  render() {
    if (!this.props.price) return null;
    const {
      enumVal = '',
      priceText,
      priceText2,
      // eslint-disable-line
      priceDisplay = 'default',
      price: {
        salepriceformatted,
        listpriceformatted,
        percentagesavings: percentsavings = 0,
        percentagesavingsformatted,
        renewalpriceformatted
      },
      termType = 'MONTH',
      perYear,
      perMonth,
      saleDiscount,
      quantifier = '',
      renewsAt,
      renewsSameDiscount
    } = this.props;
    const isOnSale = percentsavings > 0;
    const termTypeText = termType.toUpperCase() === 'YEAR' ? perYear : perMonth;
    const perTerm = quantifier === '' ? termTypeText : quantifier;
    const salePrice = isOnSale ? salepriceformatted : listpriceformatted;
    const renewsAtText = renewsAt && renewsAt.replace('{listpriceformatted}', renewalpriceformatted).replace('{term}', perTerm);
    const renewsWithDiscountText = renewsSameDiscount && percentagesavingsformatted && renewsSameDiscount.replace('{savingpercent}', percentagesavingsformatted);
    const saleText = saleDiscount && percentagesavingsformatted && saleDiscount.replace('{savingpercent}', percentagesavingsformatted);
    if (priceText) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "h4 price"
      }, priceText), priceDisplay === 'savings-renews-at-price' && /*#__PURE__*/React.createElement("div", {
        className: "text-muted"
      }, renewsAtText));
    }
    if (enumVal.toString().toLowerCase() === 'none' || priceDisplay === 'removed' || priceDisplay === 'none') return null;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "bold h4 price no-wrap-text"
    }, salePrice), /*#__PURE__*/React.createElement("span", {
      className: "text-muted bold"
    }, perTerm),
    // $1.99/mo grey strike-thru text
    // On Sale (Save 20%)
    priceDisplay === 'default' && isOnSale && /*#__PURE__*/React.createElement(_react.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "text-muted"
    }, /*#__PURE__*/React.createElement("strike", null, listpriceformatted, perTerm)), /*#__PURE__*/React.createElement("div", {
      className: "text-muted"
    }, saleText)),
    // Renews at $1.99/mo
    priceDisplay === 'savings-renews-at-price' && renewsAtText && /*#__PURE__*/React.createElement("div", {
      className: "text-muted"
    }, renewsAtText), priceDisplay === 'renews-with-discount' && renewsSameDiscount && /*#__PURE__*/React.createElement("div", {
      className: "text-muted"
    }, renewsWithDiscountText), priceText2 && /*#__PURE__*/React.createElement("div", {
      className: "text-muted"
    }, priceText2));
  }
}
exports.PriceComponent = PriceComponent;
PriceComponent.propTypes = {
  enumVal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number]),
  priceText: _propTypes.default.string,
  priceText2: _propTypes.default.string,
  perYear: _propTypes.default.string,
  perMonth: _propTypes.default.string,
  perSite: _propTypes.default.string,
  quantifier: _propTypes.default.string,
  renewsAt: _propTypes.default.string,
  priceDisplay: _propTypes.default.string,
  price: _propTypes.default.shape({
    salepriceformatted: _propTypes.default.string,
    listpriceformatted: _propTypes.default.string,
    percentagesavings: _propTypes.default.int,
    percentagesavingsformatted: _propTypes.default.string,
    renewalpriceformatted: _propTypes.default.string
  }),
  termType: _propTypes.default.string,
  renewsSameDiscount: _propTypes.default.string,
  saleDiscount: _propTypes.default.string
};
var _default = exports.default = (0, _storeProvider.provideContext)(PriceComponent);